"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var YotpoReviewReadMore = function (_a) {
    var content = _a.content;
    // State for tracking if the read more is clicked or collapsed
    var _b = (0, hooks_1.useState)(false), readMore = _b[0], setReadMore = _b[1];
    // shortened content with 350 characters at max
    var shortContent = content.substring(0, 350) + '...';
    return ((0, preact_1.h)(preact_1.Fragment, null,
        readMore ? content : shortContent,
        (0, preact_1.h)("div", { class: 'yotpo-review-read-more', onClick: function () { return setReadMore(!readMore); } },
            "Read ",
            readMore ? 'Less' : 'More')));
};
exports.default = YotpoReviewReadMore;
